/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `beat_intervals` message.
 *
 * Array of heart beat intervals
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class BeatIntervalsMesg : Mesg {
    public constructor() : super("BeatIntervals", Profile.MesgNum.BEAT_INTERVALS)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** timestamp_ms, in ms. Milliseconds past date_time */
    public var timestampMs: UShort?
        get() = getFieldValue(TIMESTAMP_MS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(TIMESTAMP_MS_FIELD_NUM, value)

    /** Number of values stored in time. */
    public val numTime: Int
        get() = getField(TIME_FIELD_NUM)?.numValues ?: 0

    /** time, in ms. Array of millisecond times between beats */
    public var time: List<UShort?>?
        get() {
            val field = getField(TIME_FIELD_NUM) ?: return null
            return List(field.numValues) { getTime(it) }
        }
        set(value) {
            removeField(TIME_FIELD_NUM)
            value?.forEachIndexed { index, element -> setTime(index, element) }
        }

    public fun getTime(index: Int): UShort? =
        getFieldValue(TIME_FIELD_NUM, index) as? UShort

    public fun setTime(index: Int, value: UShort?) {
        setFieldValue(TIME_FIELD_NUM, value, index)
    }

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val TIMESTAMP_MS_FIELD_NUM: UByte = 0u
        public const val TIME_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("TimestampMs", 0u, BaseType.UINT16, 1.0, 0.0, "ms", false)
            fields[1] = Field("Time", 1u, BaseType.UINT16, 1.0, 0.0, "ms", false)
            return fields
        }
    }
}
